import React, { useState } from 'react'
import './services.css'

const Services = () => {
    const [toggleState, setToggleState] = useState(0);

    const toggleTab = (index) => {
        setToggleState(index);
    }


  return (
    <section className="services section" id="services">
        <h2 className="section__title" data-aos="fade-right">Services</h2>
        <span className="section__subtitle" data-aos="fade-right" data-aos-delay="200">What i offer</span>

        <div className="services__container container grid">

            <div className="services__content" data-aos="fade-up">
                <div>
                    <i className="uil uil-pen services__icon"></i>
                    <h3 className="services__title title2">Copywriter</h3>
                </div>

                <span className="services__button" onClick={() => toggleTab(1)}>View More <i className="uil uil-arrow-right services__button-icon"></i></span>

                <div className={toggleState === 1 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>
                        <h3 className="services__modal-title">Copywriter</h3>
                        <p className="services__modal-description">Service with more than 1 years of experience. Providing quality work to clients and companies.</p>

                        <ul className="services__modal-services grid">
                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Create informative and interesting content to increase website traffic.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Writing attractive and selling product descriptions.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Create creative and engaging captions for Instagram, Facebook and Twitter.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Focus on messages that are easy to remember and grab the audience's attention.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Adapt the narrative to the company's values ​and mission.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="services__content" data-aos="fade-up" data-aos-delay="200">
                <div>
                    <i className="uil uil-brackets-curly services__icon"></i>
                    <h3 className="services__title">Frontend <br /> Developer</h3>
                </div>

                <span className="services__button" onClick={() => toggleTab(2)}>View More <i className="uil uil-arrow-right services__button-icon"></i></span>

                <div className={toggleState === 2 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>
                        <h3 className="services__modal-title">Frontend Developer</h3>
                        <p className="services__modal-description">Service with more than 2 years of experience. Providing quality work to clients and companies.</p>

                        <ul className="services__modal-services grid">
                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Build modern, responsive, and intuitive interfaces.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Develop web applications using frameworks such as React and Vite</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Connect frontend with API to display data dynamically.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Create engaging, user-friendly interactions, such as animations, dropdowns, or modals.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Create custom themes according to client needs.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="services__content" data-aos="fade-up" data-aos-delay="300">
                <div>
                    <i className="uil uil-web-grid services__icon"></i>
                    <h3 className="services__title">Web <br /> Development</h3>
                </div>

                <span className="services__button" onClick={() => toggleTab(3)}>View More <i className="uil uil-arrow-right services__button-icon"></i></span>

                <div className={toggleState === 3 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>
                        <h3 className="services__modal-title">Web Development</h3>
                        <p className="services__modal-description">Service with more than 1 years of experience. Providing quality work to clients and companies.</p>

                        <ul className="services__modal-services grid">
                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Create a website from scratch according to client needs.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Uses responsive design techniques for maximum user experience.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Create a safe and user-friendly online store.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Provides regular maintenance services, including bug fixes and feature updates.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Ensure the website remains secure and up-to-date.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="services__content" data-aos="fade-up" data-aos-delay="400">
                <div>
                    <i className="uil uil-game-structure services__icon"></i>
                    <h3 className="services__title">Game <br /> Developer</h3>
                </div>

                <span className="services__button" onClick={() => toggleTab(4)}>View More <i className="uil uil-arrow-right services__button-icon"></i></span>

                <div className={toggleState === 4 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>
                        <h3 className="services__modal-title">Game Developer</h3>
                        <p className="services__modal-description">Service with more than 2 years of experience. Providing quality work to clients and companies.</p>

                        <ul className="services__modal-services grid">
                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Building games with 2D graphics using the Unity3D engine</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Develop levels, challenges and game systems that appeal to players.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Create unique characters, environments and game objects.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Added sound effects, background music, and visual effects to enhance the gaming experience.</p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services__modal-icon"></i>
                                <p className="services__modal-info">Helps with the launch process on platforms such as Steam, App Store, or Google Play.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Services